<template>
    <div>
        <el-form
            v-if="formData"
            :model="formData"
           
            ref="formData"
            label-position="top"
            v-loading="dataLoading"
        >
            
            <div class="page-group-title"><span>服务</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="isOpenBooking" label="Booking:">
                        <el-radio-group v-model="formData.isOpenBooking">
                            <el-radio :label="1">开通</el-radio>
                            <el-radio :label="0">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="isSendFansNotice" label="发送粉丝通告:">
                        <el-radio-group v-model="formData.isSendFansNotice">
                            <el-radio :label="1">开通</el-radio>
                            <el-radio :label="0">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
				<el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="isSplitPayment" label="是否涉及结款分账(结给多个主办):">
                        <el-radio-group v-model="formData.isSplitPayment">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
				<el-col :xs="24" :sm="12" :xl="8" v-if="userType == 2">
			    <el-form-item prop="isShowThirdMusic" label="网易云歌曲播放:">
			        <el-radio-group v-model="formData.isShowThirdMusic">
			            <el-radio :label="1">开通</el-radio>
			            <el-radio :label="0">禁用</el-radio>
			        </el-radio-group>
			    </el-form-item>
			</el-col>
			<!-- 网易云音乐艺人ID（网易云小站id），从账号管理移入，放在云音乐开通服务后 -->
			<el-col :xs="24" :sm="12" :xl="8" v-if="userType == 2">
			    <el-form-item prop="neteaseCloudKey" label="网易云音乐艺人ID:">
			        <el-input v-model="formData.neteaseCloudKey" placeholder="请输入网易云音乐艺人ID" size="medium" maxlength="40" @input="handleNeteaseCloudKeyChange"></el-input>
			    </el-form-item>
			</el-col>
			<el-col :xs="24" :sm="12" :xl="8" v-if="userType == 2 && formData.neteaseCloudKey">
			    <el-form-item label="网易云艺人主页链接:">
			        <el-input v-model="userWangyiLink" placeholder="请输入网易云艺人主页链接" size="medium" readonly></el-input>
			    </el-form-item>
			</el-col>
            </el-row>
			<template v-if="userType == 3 ">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
					    <span>绑定抖音 POI：</span><small class="color-warning">场地绑定抖音侧的 POI 信息(地理位置),  一旦绑定无法撤销, 绑定后主办场地艺人都可以发布带该 POI 的视频</small>
					  </div>
					  <el-row :gutter="20">
						  <el-col :xs="24" :xl="16">
						      <el-form-item prop="isPushAppMsg">
						          <div class="page-group-title">
						              <span>当前绑定状态：</span>
						              <span class="MT10">
						                  <span class="color-blue ML50">{{douyinSiteStatus.get(formData.douyinSiteStatus)}}</span>
						  				<el-button size="mini" type="text" class="ML50" v-if="formData.douyinSiteStatus == 0 || formData.douyinSiteStatus == 3" @click="bindDouyin()">绑定抖音 </el-button>								
						  				<!-- <el-link class="ML50" :href="`https://aweme.snssdk.com/falcon/poi_mwa/poi_detail?poi_id=${formData.douyinSitePoiId}`" target="_blank"  type="primary" v-if="formData.douyinSitePoiId">查看绑定详情</el-link> -->
						  				<!-- <el-button size="mini" type="text" class="ML50" @click="douyinBindShow = true" >查看绑定详情</el-button> -->
						  				<el-button size="mini" type="text" class="ML50"  @click="$refs.DouyinBind.show()" v-if="formData.douyinSiteStatus != 2" >手动绑定抖音</el-button>
						  				<el-button size="mini" type="text" class="ML50"  @click="$refs.PoiidBind.show()"  v-if="formData.douyinSiteStatus != 1"  >手动保存POIID</el-button>
						  				<el-button size="mini" type="text" class="ML50"  @click="$refs.PoiidSearch.show()"  v-if="formData.douyinSiteStatus != 1"  >搜索并绑定POIID</el-button>
						              </span>
						          </div>
						      </el-form-item>
						  </el-col>
					  </el-row>
					  <el-row>
					      <el-col :xs="24" :sm="12">
					          <el-row>				               
					              <el-col><span class="color-info">状态: </span>
					  			<el-link :href="`https://aweme.snssdk.com/falcon/poi_mwa/poi_detail?poi_id=${formData.douyinSitePoiId}`" target="_blank"  type="primary" v-if="formData.douyinSitePoiId && formData.douyinSiteStatus == 2">{{douyinSiteStatus.get(formData.douyinSiteStatus)}}</el-link>
					  			<span v-else>{{douyinSiteStatus.get(formData.douyinSiteStatus)}}</span>								
					  			</el-col>					                
					              <el-col class="MT10" v-if="formData.douyinSiteBindTime"><span class="color-info">绑定时间: </span>{{formData.douyinSiteBindTime}}</el-col>
					  			<el-col class="MT10" v-if="formData.douyinSiteBindRemark && formData.douyinSiteStatus == 3 "><span class="color-info">原因: </span>{{formData.douyinSiteBindRemark}}</el-col>
					          </el-row>
					      </el-col>				        
					  </el-row>
				</el-card>
				<el-card class="box-card MT20" shadow="hover" >
					<div slot="header" class="clearfix">
					    <span>绑定美团 POI：</span><small class="color-warning">美团不支持原POI直接更新，场地名称、地址或经纬度变化后需重新绑定</small>
					  </div>
					  <el-row :gutter="20">
						  <el-col :xs="24" :xl="16">
						      <el-form-item prop="isPushAppMsg">
						          <div class="page-group-title">
						              <span>当前绑定状态：</span>
						              <span class="MT10">
						                  <span class="color-blue ML50">{{douyinSiteStatus.get(formData.meiTuanSiteStatus)}}</span>
						  				<el-button size="mini" type="text" class="ML50" v-if="formData.meiTuanSiteStatus == 0 || formData.meiTuanSiteStatus == 3" @click="bindMeituan(1)">绑定美团POI </el-button>								
						  				<el-button size="mini" type="text" class="ML50" v-if="formData.meiTuanSiteStatus == 1 || formData.meiTuanSiteStatus == 2" @click="bindMeituan(2)">重新绑定美团POI </el-button>
						              </span>
						          </div>
						      </el-form-item>
						  </el-col>
					  </el-row>
					  <el-row>
					      <el-col :xs="24" :sm="12">
					          <el-row :gutter="20">				               
					            <el-col><span class="color-info">状态: </span>					  			
					  			<span>{{douyinSiteStatus.get(formData.meiTuanSiteStatus)}}</span>								
					  			</el-col>					                
					              <el-col class="MT10" v-if="formData.meiTuanSiteBindTime"><span class="color-info">最近更新时间: </span>{{formData.meiTuanSiteBindTime}}</el-col>
					  			<el-col class="MT10" v-if="formData.meiTuanSiteBindRemark && formData.meiTuanSiteStatus == 3 "><span class="color-info">原因: </span>{{formData.meiTuanSiteBindRemark}}</el-col>
					          </el-row>
					      </el-col>				        
					  </el-row>
				</el-card>
			</template>
			<!-- <el-row :gutter="30" v-if="userType == 3">				
			    <el-col :xs="24" :xl="16">
			        <el-form-item prop="douyinActivityStatus" label="">
						<div class="page-group-title">
						    <span>绑定抖音 POI：</span><small class="color-warning">场地绑定抖音侧的 POI 信息(地理位置),  一旦绑定无法撤销, 绑定后主办场地艺人都可以发布带该 POI 的视频</small>						   
						</div>			            
			        </el-form-item>
			    </el-col>
			</el-row> -->
			<!-- <el-row :gutter="30" v-if="userType == 3">
			    <el-col :xs="24" :xl="16">
			        <el-form-item prop="isPushAppMsg">
			            <div class="page-group-title">
			                <span>当前绑定状态：</span>
			                <span class="MT10">
			                    <span class="color-blue ML50">{{douyinSiteStatus.get(formData.douyinSiteStatus)}}</span>
								<el-button size="mini" type="text" class="ML50" v-if="formData.douyinSiteStatus == 0 || formData.douyinSiteStatus == 3" @click="bindDouyin()">绑定抖音 </el-button>								
								
								<el-button size="mini" type="text" class="ML50"  @click="$refs.DouyinBind.show()" v-if="formData.douyinSiteStatus != 2" >手动绑定抖音</el-button>
								<el-button size="mini" type="text" class="ML50"  @click="$refs.PoiidBind.show()"  v-if="formData.douyinSiteStatus != 1"  >手动保存POIID</el-button>
								<el-button size="mini" type="text" class="ML50"  @click="$refs.PoiidSearch.show()"  v-if="formData.douyinSiteStatus != 1"  >搜索并绑定POIID</el-button>
			                </span>
			            </div>
			        </el-form-item>
			    </el-col>
			</el-row> -->
			<!-- <el-row v-if="userType == 3">
				<el-card shadow="never">
				    <el-row>
				        <el-col :xs="24" :sm="12">
				            <el-row>				               
				                <el-col><span class="color-info">状态: </span>
								<el-link :href="`https://aweme.snssdk.com/falcon/poi_mwa/poi_detail?poi_id=${formData.douyinSitePoiId}`" target="_blank"  type="primary" v-if="formData.douyinSitePoiId && formData.douyinSiteStatus == 2">{{douyinSiteStatus.get(formData.douyinSiteStatus)}}</el-link>
								<span v-else>{{douyinSiteStatus.get(formData.douyinSiteStatus)}}</span>								
								</el-col>					                
				                <el-col class="MT10" v-if="formData.douyinSiteBindTime"><span class="color-info">绑定时间: </span>{{formData.douyinSiteBindTime}}</el-col>
								<el-col class="MT10" v-if="formData.douyinSiteBindRemark && formData.douyinSiteStatus == 3 "><span class="color-info">原因: </span>{{formData.douyinSiteBindRemark}}</el-col>
				            </el-row>
				        </el-col>				        
				    </el-row>
				</el-card>
			</el-row> -->
			
            <el-form-item class="MT20">
                <!-- <el-button @click="goBack">返回</el-button> -->
                <el-button					
                    type="primary"
                    @click="onSave"
                    :loading="btnLoading"
                    >保 存</el-button
                >
            </el-form-item> 
        </el-form>
		<DouyinBind ref="DouyinBind" :userId="userId"  @onUpdate="getData()"></DouyinBind>
		<PoiidBind ref="PoiidBind" :userId="userId"  @onUpdate="getData()"></PoiidBind>
		<PoiidSearch ref="PoiidSearch" :userId="userId" :data="formData"  @onUpdate="getData()"></PoiidSearch>
    </div>
</template>

<script>
import DouyinBind from './douyin-bind';
import PoiidBind from './poiid-bind';
import PoiidSearch from './poiid-search';
const defaultFormData = {

    isOpenBooking:0,
    isSendFansNotice:1,
    isShowThirdMusic:'',
	isSplitPayment: 0,
	neteaseCloudKey: '' // 网易云音乐艺人ID（网易云小站id）
}
export default {
	components:{DouyinBind,PoiidBind,PoiidSearch},
    props:{
        userId:{
            type:[Number,String],
            default:''
        },
        userType:{
            type:[Number,String],
            default:''
        },
        userName:{
            type:String,
            default:''
        }
    },
    data(){
        
        return{
            dataLoading:false,
            btnLoading:false,
            formData:{
                ...defaultFormData
            },
			userWangyiLink:'', // 网易云艺人主页链接（根据艺人ID自动生成）
			douyinBindShow:false
        }
    },
    mounted(){
        this.getData();
		
    },
	computed:{	       
		douyinSiteStatus(){
		    return new Map([
		       [0,'未绑定'],
		       [1,'绑定中'],
		       [2,'绑定成功'],
		       [3,'绑定失败']
		    ])
		},
	},
    methods:{
		// 网易云音乐艺人ID输入变化时，自动生成网易云艺人主页链接
		handleNeteaseCloudKeyChange(val) {
		    if (val) {
		        this.userWangyiLink = 'https://music.163.com/#/artist?id=' + val;
		    } else {
		        this.userWangyiLink = '';
		    }
		},
        //获取账号信息
        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/userCommon/getUserServiceInfo',
                method: "POST",
                params: {userId: this.userId},
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg, result } = res.data;
                    if (state && state == 1) {
                        this.formData = {
                            ...defaultFormData, 
                            ...result,
                            userId: this.userId, 
							userName:result.name
                            
                        };
                        // 回显网易云艺人主页链接
						if( this.userType == 2 && result && result.neteaseCloudKey ){
							this.userWangyiLink = 'https://music.163.com/#/artist?id=' + result.neteaseCloudKey
						}
                        this.$emit('update:userName',result.name)
                    } else {
                        return this.$message.error(msg || "获取账号信息失败");
                    }
                }).catch(() => {
                    return this.$message.error("获取账号信息失败");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
		bindDouyin(){
			
			var that = this
		    that.$confirm('确定要绑定场地: ' +this.formData.name+ '到抖音POI吗？一旦操作不可撤销!', '提示', {
		        type: 'warning',
		        center: true,
		        confirmButtonText:'确定',
		        cancelButtonText:'取消',
		        closeOnClickModal: false
		    }).then( () => {
		        that.$request({
		            url: '/site/bindDouyin',
		            method: 'POST',
		            params: {id:this.userId},
		        }).then(res=> {
		            let { state, msg } = res.data;
		            if (state == 1) {
		                that.$message.success("操作成功");
		                that.getData();
		            }else{
		                that.$message.error(msg || "请求失败");
		            }
		        })
		    })
		},
		bindAliPoi(){ //5581347899去掉了
			this.$request({
			    url: '/site/bindAliPoi',
			    method: 'POST',
			    params: {siteId:this.userId,poiId:this.formData.aliPoiId},
			}).then(res=> {
			    let { state, msg } = res.data;
			    if (state == 1) {
			        this.$message.success("操作成功");
			        this.getData();
			    }else{
			        this.$message.error(msg || "请求失败");
			    }
			})
		},
		//绑定美团
		bindMeituan(type) {
		  const _title = type === 1 ? '绑定美团POI' : '重新绑定确认';
		  const that = this;		 
		  const messageVNode = this.$createElement('div', [		    
		    this.$createElement(
		      'p',
		      type === 1
		        ? `确定要绑定场地: ${this.formData.name} 到美团POI吗？一旦操作不可撤销！`
		        : '确认重新绑定该场地的美团 POI 后，当前挂在该场地下的所有推送成功演出都会先下架，再按新的 POI 重新推送。'
		    ),		    
		    type === 2 &&
		      this.$createElement(
		        'el-alert',
		        {
		          props: {
		            type: 'warning',
					closable: false 
		          },
		          style: {
		            display: 'block',
		            marginTop: '10px'
		          }
		        },
		       
		        '请先确认新的场地名称、地址、经纬度信息无误，再执行重新绑定，避免演出重复下架或重新推送失败。'
		      )
		  ].filter(Boolean));
		
		  // 调用 $confirm
		  this.$confirm(messageVNode, _title, {
		    confirmButtonText: '确定',
		    cancelButtonText: '取消',
		    closeOnClickModal: false,
		   
		  }).then(() => {
		    that.$request({
		      url: '/site/bindMeiTuan',
		      method: 'POST',
		      params: { id: that.userId },
		    }).then(res => {
		      const { state, msg } = res.data;
		      if (state == 1) {
		        that.$message.success('操作成功');
		        that.getData();
		      } else {
		        that.$message.error(msg || '请求失败');
		      }
		    });
		  }).catch(() => {});
		},
        //表单提交
       
        onSave(){
            this.btnLoading = true;
            this.$request({
                url: '/userCommon/saveUserServiceInfo',
                method: "POST",
                data: this.formData,
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$message.success("操作成功");
                    } else {
                        return this.$message.error(msg || "操作失败");
                    }
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        }
    }
}
</script>
<style lang="scss" scoped>

.ML50{
	margin-left: 50px;
}
::v-deep .el-alert{
	padding:8px;
}
::v-deep .el-alert .el-alert__description{
	font-size: 14px;
}
</style>